import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';

@Injectable()
export class HomeService extends SecurityService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger);
  }

  public getCurrentUser(): Observable<any> {
    //let cookie = localStorage.getItem('home_cookie') == null ? '' : localStorage.getItem('home_cookie');
    let serviceUrl = this.baseUrl + 'home/companyHeader';
    return this.request(serviceUrl).pipe(
      map((response) => {
        let body = response.json();
        localStorage.setItem('home_info', JSON.stringify(body));
        localStorage.setItem('home_cookie', body.cookieId);
      }),
      catchError(super.handleError),
    );
  }
  public getStats(debtorId) {
    let serviceUrl = this.baseUrl + 'home/getRegisterdInv?dbtrId=' + debtorId;
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  public getStatsPerStatus(debtorId) {
    let serviceUrl = this.baseUrl + 'home/getRegisteredInvStatus?dbtrId=' + debtorId;
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
}
